export const CLEAR_STORE = 'CLEAR_STORE';
export const CLEAR_APPLICATION = 'CLEAR_APPLICATION';

// Tells the root reducer to completely clear the redux store, used for 401 encounters
export const clearStore = () => ({ type: CLEAR_STORE, payload: true })

// Tells the root reducer to clear application-related entities (for use after app is submitted)
export const clearApplication = () => ({ type: CLEAR_APPLICATION, payload: true })